import {
  AiResponseReviewHealthMetrics,
  AiResponseReviewQueryModel,
  AiResponseReviewResult,
  AiResponseReviewUpdateInternalModel,
  AiResponseReviewUpdateModel,
  ClientWeeklyUsage,
  PagedResult,
  PromptCategorySummaryResult,
  UtilizationTrendPoint
} from "@app/operations/ai-response-review/interfaces";
import { ClientListItem } from "@app/client/client";
import ServiceBase from "@app/shared/serviceBase";

export class AiResponseReviewService extends ServiceBase {

  public async getAiResponseReviews(query: AiResponseReviewQueryModel, signal?: AbortSignal): Promise<PagedResult<AiResponseReviewResult>> {
    return await this.makePost<PagedResult<AiResponseReviewResult>>('chatbot/ai-response-reviews', query, undefined, false, "application/json", true, undefined, signal);
  }

  public async getAiResponseReview(responseId: number): Promise<AiResponseReviewResult> {
    return await this.makeGet<AiResponseReviewResult>(`chatbot/ai-response-reviews/${responseId}`);
  }

  public async updateInternalAiResponseReview(responseId: number, update: AiResponseReviewUpdateInternalModel): Promise<void> {
    return await this.makePut<void>(`chatbot/ai-response-reviews/${responseId}/update-internal-review`, update);
  }

  public async updateAiResponseReview(responseId: number, update: AiResponseReviewUpdateModel): Promise<void> {
    return await this.makePut<void>(`chatbot/ai-response-reviews/${responseId}/update-review`, update);
  }

  public async updateTableDownloaded(responseId: number, tableDownloaded: boolean): Promise<void> {
    return await this.makePut<void>(`chatbot/ai-response-reviews/${responseId}/update-table-downloaded`, { tableDownloaded });
  }

  public async getMostRecentPromptCategorySummary(): Promise<PromptCategorySummaryResult | null> {
    return await this.makeGet<PromptCategorySummaryResult | null>('chatbot/ai-response-reviews/prompt-category-summary');
  }

  public async generatePromptCategorySummary(): Promise<PromptCategorySummaryResult> {
    return await this.makePost<PromptCategorySummaryResult>('chatbot/ai-response-reviews/prompt-category-summary/generate');
  }

  public async getHealthMetrics(signal?: AbortSignal): Promise<AiResponseReviewHealthMetrics> {
    return await this.makeGet<AiResponseReviewHealthMetrics>('chatbot/ai-response-reviews/health-metrics', undefined, undefined, false, undefined, signal);
  }

  public async getUtilizationTrend(clientId?: number): Promise<UtilizationTrendPoint[]> {
    return await this.makeGet<UtilizationTrendPoint[]>('chatbot/ai-response-reviews/utilization-trend', { clientId });
  }

  public async getClientWeeklyUsage(clientId: number): Promise<ClientWeeklyUsage> {
    return await this.makeGet<ClientWeeklyUsage>(`chatbot/ai-response-reviews/client-weekly-usage/${clientId}`);
  }

  public async getUtilizationTrendClients(): Promise<ClientListItem[]> {
    return await this.makeGet<ClientListItem[]>('chatbot/ai-response-reviews/clients');
  }
}
